module.exports = __webpack_public_path__ + "static/media/google-play-best-2019@2x.4cd6f7dc.png";